import React, { useEffect, useState } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import {
  Alert,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from 'reactstrap';
import { deleteSurvey, restoreSurvey } from '../../api/survey';

const DeleteSurveyModal = ({
  open,
  handleClose,
  surveyId,
  surveyName,
  fetchNewData,
  showSuccessAlert
}) => {
  const [requestLoading, setRequestLoading] = useState(false);
  const [requestError, setRequestError] = useState({
    show_alert: false,
    message: ''
  });

  function showErrorAlert(message) {
    setRequestError({ message: message, show_alert: true });
  }

  function resetErrorAlert() {
    setRequestError({ message: '', show_alert: false });
  }

  const handleDeleteSurvey = async () => {
    resetErrorAlert();
    setRequestLoading(true);
    try {
      await deleteSurvey(surveyId);
      showSuccessAlert(`Survey deleted successfully`);
      fetchNewData();
      handleClose();
    } catch (error) {
      showErrorAlert(
        error?.response?.data?.error ||
          error?.response?.data?.message ||
          'Failed to delete survey'
      );
      console.error('Failed to delete survey: ', error);
    } finally {
      setRequestLoading(false);
    }
  };

  useEffect(() => {
    resetErrorAlert();
  }, [open]);

  return (
    <React.Fragment>
      <Modal isOpen={open} backdrop="static" size="md">
        <ModalHeader toggle={handleClose}></ModalHeader>
        <ModalBody>
          {requestError ? (
            <Alert
              color="danger"
              role="alert"
              isOpen={requestError.show_alert}
              toggle={resetErrorAlert}
            >
              <i className="mdi mdi-block-helper mr-2"></i>
              {requestError.message}
            </Alert>
          ) : null}
          <h4>
            {`Are you sure you want to delete ${
              surveyName ? `${surveyName}'s` : 'this'
            }`}{' '}
            survey?
          </h4>
        </ModalBody>
        <ModalFooter>
          <Button
            disabled={requestLoading}
            type="button"
            color="light"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            color="danger"
            onClick={() => handleDeleteSurvey()}
          >
            {requestLoading ? 'Deleting...' : 'Delete'}
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default DeleteSurveyModal;
